import {fontSizeTable, smFontSizeTable} from "../../../../../utils/constants";
import { SECTION_PADDING } from '../../../constants';

const SORTING_INDICATOR_WIDTH = 18;

const styles = theme => ({
   root: {
     minHeight: 150,
     width: '100%'
   },
   container: {
      overflowX: 'auto'
   },
   tableAll: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    '& td': {
      width: 68 + SORTING_INDICATOR_WIDTH,
      padding: 5,
      verticalAlign: 'top',
      textAlign: 'right',
      [theme.breakpoints.up('md')]: {
        '&:first-child': {
          paddingLeft: SECTION_PADDING
        }
      },

      '&:first-child': {
        width: 300,
        [theme.breakpoints.down(800)]: {
          width: 150,
        },
      },

      '&:last-child': {
        width: 132 + SORTING_INDICATOR_WIDTH
      },

      '&:nth-child(2)': {
        width: 96 + SORTING_INDICATOR_WIDTH
      },

      '&:nth-child(3)': {
        width: 98 + SORTING_INDICATOR_WIDTH
      },

      '&:nth-child(6)': {
        width: 72 + SORTING_INDICATOR_WIDTH
      }

    },
    '& tbody tr': {
      borderBottom: 'solid 1px #D8DCDF',
      color: '#202A38',
      '&:last-of-type': {
        borderBottom: 'none'
      },
      '& td': {
        fontSize: fontSizeTable,
        fontFamily: 'Roboto-Regular',
        [theme.breakpoints.down('sm')]: {
          fontSize: smFontSizeTable
        },
      },
      '& td div.sub': {
        fontSize: smFontSizeTable,
        fontFamily: 'Roboto-Regular',
        color: '#80858C',
        [theme.breakpoints.down('sm')]: {
          fontSize: smFontSizeTable - 2
        },
      }
    }
  },
  tableHeader: {
    '& td': {
      fontFamily: 'Roboto-Bold !important',
      fontSize: fontSizeTable,
      color: '#80858C',
      backgroundColor: '#F5F6F7',
      [theme.breakpoints.down('sm')]: {
        fontSize: smFontSizeTable
      },
    },
    '& td:first-of-type': {
      [theme.breakpoints.up('md')]: {
        paddingLeft: SECTION_PADDING,
      },
      textAlign: 'left',
    },
    '& td:nth-child(3)': {
      textAlign: 'left',
    },
    '& td div.sub': {
      fontFamily: 'Roboto-Regular !important',
    }
  },
  assetName: {
    fontFamily: 'Roboto-Bold',
    color: `${theme.palette.primary.main} !important`,
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
      background: 'none',
      textDecoration: 'underline !important'
    },
    display: 'inline-block',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  leftAligned: {
    textAlign: 'left !important'
  },
  ratingFilled: {
    color: theme.palette.primary.main
  },
  helpIcon: {
    marginLeft: 5,
    verticalAlign: 'baseline',
    color: theme.palette.primary.main,
    fontSize: 16,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  benchmarkIcon: {
    display: 'inline-block',
    marginRight: 3
  },
  containerError: {
    height: 'calc(100% - 60px)',
  },
  contentWrapper: {
    paddingTop: '0!important',
    height: '100%'
  }
})

export default styles;